export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const CONFLICT = 409;

export const INTERNAL_SERVER_ERROR = 500; // uncaught exception
export const NOT_IMPLEMENTED = 501; // unhandled verb
export const BAD_GATEWAY = 502; // invalid response
export const SERVICE_UNAVAILABLE = 503; // server not ready/down/overloaded
export const GATEWAY_TIMEOUT = 504; // no response in time

export const SERVER_ERRORS = [
    INTERNAL_SERVER_ERROR,
    NOT_IMPLEMENTED,
    BAD_GATEWAY,
    SERVICE_UNAVAILABLE,
    GATEWAY_TIMEOUT,
];



// WEBPACK FOOTER //
// ./scripts/constants/httpStatusCodes.js